/// <reference types="react-scripts" />
import * as React from "react";
import * as publicUserService from "../../../models/services/publicUserService";
import LogoEsalkku from "../../../../../Content/devel/images/logo_eSalkku.png";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "source/framework/saveData";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { Alert, Box, Grid, TextField } from "@mui/material";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { IUserPasswordChangePageData } from "source/models/user/userPasswordChangePageData";
import { useEffect, useState } from "react";
import { Dialog } from "source/components/framework/Dialog/Dialog";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";

interface IUserInvitationPageContentProps {
    token: string;
}

interface IUserInvitationPageContentState {
    pageData: IUserPasswordChangePageData;
    usercode: string;
    password: string;
    passwordConfirmation: string;
}

export const UserInvitationPageContent = (props: IUserInvitationPageContentProps) => {
    const [state, setState] = useState<IUserInvitationPageContentState>({
        pageData: null,
        usercode: "",
        password: "",
        passwordConfirmation: ""
    });
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);

    const loadPageData = async () => {
        const pageData = await AppUtils.callService(() => publicUserService.getUserPasswordChangePageData(props.token));
        if (!pageData) return;
        Translations.setCulture(pageData.culture);
        publicUserService.setCulture(pageData.culture);
        setState((old) => ({
            ...old,
            pageData
        }));
    };

    useEffect(() => {
        loadPageData();
    }, []);

    const handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "x_u_c") {
            setState((old) => ({
                ...old,
                usercode: value
            }));
        } else if (name === "x_n_p") {
            setState((old) => ({
                ...old,
                password: value
            }));
        } else if (name === "x_n_pc") {
            setState((old) => ({
                ...old,
                passwordConfirmation: value
            }));
        }
    };
    
    const checkErrors = (): Promise<boolean> => {
        return new Promise<boolean>((resolve) => {
            if (!state.usercode) {
                AppUtils.showErrorMessage(Translations.UserCodeMustBeDefined);
                return resolve(false);
            }
            if (!state.password) {
                AppUtils.showErrorMessage(Translations.UserPasswordMustBeDefined);
                return resolve(false);
            }
            const errorMessage = Base.isValidPassword(state.password, state.pageData.minPasswordLength);
            if (errorMessage) {
                AppUtils.showErrorMessage(errorMessage);
                return resolve(false);
            }
            if (state.password !== state.passwordConfirmation) {
                AppUtils.showErrorMessage(Translations.PasswordConfirmationDoesNotMatchPassword);
                return resolve(false);
            }
            return resolve(true);
        });
    };

    const getSaveDataFromState = (): SaveDataObj => {
        const data = new SaveDataObj();
        data.append("token", props.token);
        data.append("usercode", state.usercode);
        data.append("password", state.password);
        return data;
    };

    const handleSavePassword = async () => {
        if (!await AppUtils.validate(checkErrors)) return null;
        const saveData = getSaveDataFromState();
        //Call server
        const result = await AppUtils.callService(() => publicUserService.saveUserPassword(saveData.obj));
        if (!result) return null;
        // window.setTimeout(() => {
        //     window.location.href = appConfig.rootUrl + "Front";
        // }, 1000);
        setShowSuccessDialog(true);
        return result;
    };

    const closeSuccessDialog = () => {
        setShowSuccessDialog(false);
        window.location.href = appConfig.rootUrl + "Front";
    };

    return (
        <div>
            <Box sx={{ width: "340px", marginLeft: "auto", marginRight: "auto", marginTop: "-50px", padding: "20px" }}>
                <Alert severity="info" sx={{ marginBottom: "0.5rem" }}>{state.pageData?.isInvitation ? Translations.WelcomeToUseEsalkkuSystem : Translations.UserPublicPasswordChangeMessage}</Alert>
                <GridRow>
                    <Grid item xs={12} sx={{ marginBottom: "1rem" }}>
                        <Box component="img" alt="logo" src={LogoEsalkku} sx={{ maxHeight: "100px", maxWidth: "100%" }} />
                    </Grid>
                </GridRow>
                <GridRow>
                    <Grid item xs={12}>
                        <FormField title={Translations.UserName} required margin="0.5rem 0 0 0">
                            <TextField type="text" name="x_u_c" title={Translations.UserName} inputProps={{ maxLength: 50, autoComplete: "off" }} disabled={!state.pageData} value={state.usercode} required={true} onChange={handleChange} size="small" fullWidth />
                        </FormField>
                    </Grid>
                </GridRow>
                <GridRow>
                    <Grid item xs={12}>
                        <FormField title={Translations.Password} required margin="0.5rem 0 0 0">
                            <TextField type="password" name="x_n_p" title={Translations.Password} inputProps={{ maxLength: 50, autoComplete: "new-password" }} disabled={!state.pageData} value={state.password} required={true} onChange={handleChange} size="small" fullWidth />
                        </FormField>
                    </Grid>
                </GridRow>
                <GridRow>
                    <Grid item xs={12}>
                        <FormField title={Translations.ConfirmPassword} required margin="0.5rem 0 0 0">
                            <TextField type="password" name="x_n_pc" title={Translations.ConfirmPassword} inputProps={{ maxLength: 50, autoComplete: "new-password" }} disabled={!state.pageData} value={state.passwordConfirmation} required={true} onChange={handleChange} size="small" fullWidth />
                        </FormField>
                    </Grid>
                </GridRow>
                <GridRow>
                    <Grid item xs={12}>
                        <AppButton variant="contained" sx={{ marginTop: "1rem" }} onClick={handleSavePassword} disabled={!state.pageData} fullWidth>
                            {Translations.SavePasswordAndMoveToLoginPage}
                        </AppButton>
                    </Grid>
                </GridRow>
            </Box>
            {showSuccessDialog &&
                <Dialog
                    id="invitationRequestSuccessDialog"
                    maxWidth="xs"
                    title={Translations.Success}
                    body={Translations.PasswordHasBeenSetSuccessfully}
                    buttons={[
                        { title: Translations.Close, variant: "outlined", onClick: closeSuccessDialog }
                    ]}
                    onClose={closeSuccessDialog}
                />
            }
        </div>
    );
};